const setMetaTag = (name, content, property = false) => {
    const metaTag = document.querySelector(property ? `meta[property="${name}"]` : `meta[name="${name}"]`);
    if (metaTag) {
        metaTag.setAttribute('content', content);
    } else {
        const meta = document.createElement('meta');
        if (property) {
            meta.setAttribute('property', name);
        } else {
            meta.setAttribute('name', name);
        }
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
    }
};

const _baseURL = 'https://www.freddiefiggers.com/';
const SEOTags = (
    title,
    description,
    keywords,
    imageUrl = _baseURL+'ff_thumbnail.jpg',
    url = _baseURL
) => {
    document.title = title;

    setMetaTag('description', description);
    // Consider removing keywords if not needed
    setMetaTag('keywords', keywords);

    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:image', imageUrl, true);
    setMetaTag('og:url', url, true);

    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', imageUrl);
};

export default SEOTags;